module.exports = __webpack_public_path__ + "static/media/kv.8a346da8.jpg";